import { render, staticRenderFns } from "./Claim-Catergory.vue?vue&type=template&id=1b57e4c8&scoped=true"
import script from "./Claim-Catergory.vue?vue&type=script&lang=js"
export * from "./Claim-Catergory.vue?vue&type=script&lang=js"
import style0 from "./Claim-Catergory.vue?vue&type=style&index=0&id=1b57e4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57e4c8",
  null
  
)

export default component.exports